import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './core/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { QueryParamHandlerService } from './core/services/query-param-handler.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import packageJson from '../../package.json';

export function initializeAppFactory(queryParamHandler: QueryParamHandlerService): () => void {
  // Al iniciar la app, le pedimos al servicio que revise los query params.
  return () => queryParamHandler.handleQueryParams();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideTranslateService({
      lang: 'es',
      fallbackLang: 'es',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: `.json?v=${packageJson.version}`,
      }),
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [QueryParamHandlerService], // Las dependencias que necesita tu factory
      multi: true // Esencial para que no sobreescriba otros inicializadores
    }
  ],
};
